import { Injectable } from '@angular/core';
import { IOrchestrationDto } from 'src/app/models/orchestrations';
import { OrchestrationService } from './orchestration.service';

@Injectable({
  providedIn: 'root'
})
export class OrchestrationOrchestrationService {

    allOrchestrations: IOrchestrationDto[] = [];

    constructor(private service: OrchestrationService) { }

    async getAllOrchestrations(): Promise<IOrchestrationDto[]>
    {
        this.allOrchestrations = await this.service.getOrchestrations();
        return this.allOrchestrations;
    }

    getOrchestrationNameList(): {name: string, channelType: string}[] {

        let itm: {name: string, channelType: string}[] = [];

        this.allOrchestrations.forEach(entity=> {
            itm.push({name: entity.name, channelType: entity.channelType});
        })

        return itm;
    }

    getOrchestrationName(Id: number): string {

        let itm: string;

        this.allOrchestrations.forEach(entity=> {
            if( entity.id == Id)
            {
                itm = entity.name;
            }
        })

        return itm;
    }

    getOrchestrationByName(name: string): IOrchestrationDto {

        let itm: IOrchestrationDto;

        this.allOrchestrations.forEach(entity=> {
            if( entity.name == name)
            {
                itm = entity;
            }
        })

        return itm;
    }

    getOrchestrationEffortId(Id: number) {

        let itm: number;

        this.allOrchestrations.forEach(entity=> {
            if( entity.id == Id)
            {
                itm = entity.effortId;
            }
        })

        return itm;
    }
    
    getChannelType(Id: number): string {

        let itm: string;

        this.allOrchestrations.forEach(entity=> {
            if( entity.id == Id)
            {
                itm = entity.channelType;
            }
        })

        return itm;
    }

    getOrchestrationId(name: string): number {

        let itm: number;

        this.allOrchestrations.forEach(entity=> {
            if( entity.name == name)
            {
                itm = entity.id;
            }
        })

        return itm;
    }

    async deleteAllEffortReferences(id: number) {

        let orchestrations: IOrchestrationDto[] = [];

        if(this.allOrchestrations == null || this.allOrchestrations.length == 0)
        {
            await this.getAllOrchestrations();
        }

        this.allOrchestrations.forEach(element=> {
            if(element.effortId == id)
            {
                element.effortId = null;
                orchestrations.push(element);
            }
        })

        if(orchestrations != null )
        {
            let promise: Promise<IOrchestrationDto>[] = [];

            orchestrations.forEach(orch=> {

                promise.push(this.service.saveOrchestrationChange(orch));

            })

            await Promise.all(promise);
        }
    }

    async saveOrchestrationItem(orchestration: IOrchestrationDto) : Promise<IOrchestrationDto>{

        if(orchestration.id == 0)
        {
            orchestration = await this.service.saveCreateOrchestrationChange(orchestration);
            await this.getAllOrchestrations();
        }
        else
        {
            await this.service.saveOrchestrationChange(orchestration);
        }

        return orchestration;
    }

    getNewOrchestrationItem(): IOrchestrationDto {

        return {
            id: 0,
            channelType: null,
            name: null,
            cadence: null,
            mode: null,
            applicationIntent: null,
            retryInterval: 1,
            retryTimes: 1,
            metadata: null,
            effortId: null,
            description: null
        }
    }
}
